import { validators } from '../utils/validators';

/** Validation schema for staff ↔ client chat composer (used by MessagesTab). */
export const messageFormSchema = {
  content: [validators.required, validators.minLength(1), validators.maxLength(5000)],
};
